// extracted by mini-css-extract-plugin
export default {"header":"style_header__KQ7vL","closeIcon":"style_closeIcon__nhtgR"};